<form [formGroup]="form" nz-form nzLayout="vertical">
	<div nz-row [nzGutter]="16">
		<div nz-col [nzSpan]="12">
			<nz-form-item>
				<nz-form-label nzRequired>Rule Type</nz-form-label>
				<nz-form-control nzErrorTip="Please select a rule type">
					<nz-select formControlName="ruleType" nzPlaceHolder="Select rule type">
						<nz-option *ngFor="let item of availableRuleTypes" [nzValue]="item" [nzLabel]="item"></nz-option>
					</nz-select>
				</nz-form-control>
			</nz-form-item>
		</div>

		<div nz-col [nzSpan]="12">
			<nz-form-item>
				<nz-form-label nzRequired>Applied To</nz-form-label>
				<nz-form-control nzErrorTip="Please select who this applies to">
					<nz-select formControlName="appliedTo" nzPlaceHolder="Select member type">
						<nz-option *ngFor="let item of availableAppliedTos" [nzValue]="item" [nzLabel]="item"></nz-option>
					</nz-select>
				</nz-form-control>
			</nz-form-item>
		</div>
	</div>

	<div nz-row [nzGutter]="16">
		<div nz-col [nzSpan]="12">
			<nz-form-item>
				<nz-form-label nzRequired>Threshold (Value)</nz-form-label>
				<nz-form-control nzErrorTip="Please enter a threshold value">
					<nz-input-number formControlName="threshold" [nzMin]="0" [nzStep]="1" style="width: 100%">
					</nz-input-number>
				</nz-form-control>
			</nz-form-item>
		</div>
	</div>
</form>

<div *nzModalFooter>
	<button nz-button nzType="default" (click)="onCancel()">Cancel</button>
	<button nz-button nzType="primary" [disabled]="this.form.invalid" (click)="onSave()">Save</button>
</div>
